module.exports = __webpack_public_path__ + "img/bs.6703bb14.jpg";